"use client";

import React, { useEffect, useRef } from "react";
import * as THREE from "three";
import { useDevice } from "@/hooks/useDevice";
import MobileOnboarding from "@/mobileComponents/MobileOnboarding/MobileBulkOrderOnboarding";
import Onboarding from "@/components/onboarding/BulkOrderOnboarding";

const Page: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
const isMobile = useDevice();
  useEffect(() => {
  if (!canvasRef.current) return;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    0.1,
    1000
  );
  camera.position.z = 5;

  const renderer = new THREE.WebGLRenderer({ canvas: canvasRef.current, alpha: true });
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.setPixelRatio(window.devicePixelRatio);

  // Create particles
  const particleCount = 500;
  const particles = new THREE.BufferGeometry();
  const positions = new Float32Array(particleCount * 3);

  for (let i = 0; i < particleCount * 3; i++) {
    positions[i] = (Math.random() - 0.5) * 10;
  }

  particles.setAttribute("position", new THREE.BufferAttribute(positions, 3));

  const material = new THREE.PointsMaterial({
    color: 0xffffff,
    size: 0.05,
  });

  const points = new THREE.Points(particles, material);
  scene.add(points);

  // Smooth color transition setup
  const colors = ["#0ea5e9", "#8b5cf6", "#ec4899"];
  let colorIndex = 0;
  const currentColor = new THREE.Color(colors[0]);
  let targetColor = new THREE.Color(colors[1]);

  const animate = () => {
    requestAnimationFrame(animate);

    // Particle animation
    points.rotation.y += 0.001;
    points.rotation.x += 0.0005;

    // Smooth background color transition
    currentColor.lerp(targetColor, 0.005); // Slower transition
    renderer.setClearColor(currentColor, 1);

    renderer.render(scene, camera);
  };

  animate();

  const handleResize = () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
  };

  window.addEventListener("resize", handleResize);

  // Update the target color every 6 seconds
  const colorInterval = setInterval(() => {
    colorIndex = (colorIndex + 1) % colors.length;
    targetColor = new THREE.Color(colors[colorIndex]);
  }, 6000);

  return () => {
    window.removeEventListener("resize", handleResize);
    clearInterval(colorInterval);
    renderer.dispose();
  };
}, []);


  return (
     <div className="relative w-full min-h-screen max-h-screen flex items-center justify-center">
      <canvas ref={canvasRef} className="absolute top-0 left-0 w-screen h-screen z-0" />
      <div className="z-10 p-6 w-full max-h-screen max-w-screen-md">
        {isMobile ? <MobileOnboarding /> : <Onboarding />}
      </div>
    </div>
  );
};

export default Page;
